import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";

const EditProductTypeComponent = loadable(
  () => import("../../components/ProductType/EditProductType")
);
const EditProductType = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: [`product-type-${id}`],
    url: `${APIS.PRODUCT_TYPE}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`product-type-${id}`],
    navigateURL: "/product-type",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.PRODUCT_TYPE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit ProductType</span>
      </div>
      <EditProductTypeComponent
        isLoading={isPatchLoading}
        refetch={refetch}
        handleEdit={handleEdit}
      />
    </>
  );
};
export default EditProductType;
